import {cn} from '@/lib/utils';
import {TypeEffect} from '../TypeEffect';
import styles from './Assistant.module.css';
export interface AssistantProps {
  className?: string;
  detail: string;
  detailDelay?: number;
  detailInterval?: number;
  onDetailEnd?: () => void;
  onSummaryEnd?: () => void;
  summary: string;
  summaryDelay?: number;
  summaryInterval?: number;
}
export const Assistant = ({
  className,
  detail,
  detailDelay = 300,
  detailInterval = 15,
  onDetailEnd,
  onSummaryEnd,
  summary,
  summaryDelay = 0,
  summaryInterval = 15,
}: AssistantProps) => {
  return (
    <div className={cn(className, 'flex items-center gap-4')}>
      <div className={'flex items-center justify-center text-6xl'}>🤓</div>
      <div className={styles.chat}>
        <strong>
          {summaryInterval > 0 && (
            <TypeEffect delay={summaryDelay} interval={summaryInterval} onEnd={onSummaryEnd} text={summary ?? ''} />
          )}
          {summaryInterval === 0 && summary}
        </strong>
        {detailInterval === 0 && detail}
        {detailInterval > 0 && (
          <TypeEffect
            delay={detailDelay + summaryDelay + (summary?.length ?? 0) * summaryInterval}
            interval={detailInterval}
            onEnd={onDetailEnd}
            text={detail ?? ''}
          />
        )}
      </div>
    </div>
  );
};
